import { FaCheck } from 'react-icons/fa';
import Tooltip from 'components/Tooltip';
import styled, { css } from 'styled-components';
import { colors, th, variants } from 'style/theme';

interface ContainerProps {
  size?: 'medium' | 'large' | 'extralarge';
  className?: string;
}

export const Container = styled.div<ContainerProps>`
  ${variants('size', {
    medium: css`
      margin-bottom: 22px;
    `,
    large: css`
      margin-bottom: 30px;
    `,
    extralarge: css`
      margin-bottom: 40px;
    `
  })}

  position: relative;
  width: 100%;

  :last-of-type {
    margin-bottom: 0;
  }

  input {
    margin: 0px;
  }
`;

export const Optional = styled.span`
  font-weight: 400;
  font-size: 14px;
  margin-left: 4px;
`;

export const ErrorMessage = styled.span`
  margin-left: 5px;
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;

export const CheckIcon = styled(FaCheck)`
  margin-left: 7px;
  font-size: 14px;
  color: ${th('colors.bermudaGreen')};
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 8px;
`;

export const Comment = styled.div`
  font-weight: normal;
  font-size: 15px;
`;

export const NewInputStyle = css`
  background: ${colors.pickledBluewoodLight4};
  border-radius: 16px;
  padding: 8px 14px;

  > input {
    font-family: Inter;
    font-style: normal;
    color: ${colors.pickledBluewood};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    padding: 0;
    border: none;
  }

  > label {
    font-family: Inter;
    color: ${colors.pickledBluewoodLight2};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    > svg {
      display: none;
    }

    > span {
      font-size: 12px;
    }
  }
`;
